export default __webpack_public_path__ + "static/media/ottweiler_light.e18fab11.png";